import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { usePortal } from '../PortalAuth';
import { useDashboardData } from '../dashboard/useDashboardData';
import DashExecutive from '../dashboard/DashExecutive';
import DashRosso from '../dashboard/DashRosso';
import AreaButtons from '../dashboard/AreaButtons';
import MonitoringEventsCard from '../dashboard/MonitoringEventsCard';
import ApiUsagePage from './ApiUsagePage';
import { apiOnly } from '../shells/nav';

export default function DashboardPage() {
  const { user } = usePortal();
  return apiOnly(user) ? <ApiUsagePage /> : <FullDashboard />;
}

function FullDashboard() {
  const { user } = usePortal();
  const { design } = useOutletContext();
  const data = useDashboardData();
  const View = design === 'rosso' ? DashRosso : DashExecutive;
  return <><AreaButtons /><View user={user} data={data} /><MonitoringEventsCard design={design} /></>;
}
